import { render, staticRenderFns } from "./EditApiFrom.vue?vue&type=template&id=16c7e4dc"
import script from "./EditApiFrom.vue?vue&type=script&lang=js"
export * from "./EditApiFrom.vue?vue&type=script&lang=js"
import style0 from "./EditApiFrom.vue?vue&type=style&index=0&id=16c7e4dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports